import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

// AUTH
export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));
export const RegisterPage = Loadable(lazy(() => import('../pages/auth/RegisterPage')));
export const VerifyCodePage = Loadable(lazy(() => import('../pages/auth/VerifyCodePage')));
export const NewPasswordPage = Loadable(lazy(() => import('../pages/auth/NewPasswordPage')));
export const ResetPasswordPage = Loadable(lazy(() => import('../pages/auth/ResetPasswordPage')));

// DASHBOARD: GENERAL
export const GeneralAppPage = Loadable(lazy(() => import('../pages/dashboard/GeneralAppPage')));

export const GeneralAnalyticsPage = Loadable(
  lazy(() => import('../pages/dashboard/GeneralAnalyticsPage'))
);
export const AISettingsPage = Loadable(lazy(() => import('../pages/dashboard/AISettingsPage')));

// DASHBOARD: USER
export const UserProfilePage = Loadable(lazy(() => import('../pages/dashboard/UserProfilePage')));
export const UserCardsPage = Loadable(lazy(() => import('../pages/dashboard/UserCardsPage')));
export const UserListPage = Loadable(lazy(() => import('../pages/dashboard/UserListPage')));
export const UserAccountPage = Loadable(lazy(() => import('../pages/dashboard/UserAccountPage')));
export const UserCreatePage = Loadable(lazy(() => import('../pages/dashboard/UserCreatePage')));
export const UserEditPage = Loadable(lazy(() => import('../pages/dashboard/UserEditPage')));

// DASHBOARD: Task
// export const TaskProfilePage = Loadable(lazy(() => import('../pages/dashboard/TaskProfilePage')));
// export const TaskCardsPage = Loadable(lazy(() => import('../pages/dashboard/TaskCardsPage')));
export const TaskListPage = Loadable(lazy(() => import('../pages/dashboard/TaskListPage')));
export const ApprovedListPage = Loadable(lazy(() => import('../pages/dashboard/ApprovedClaimsPage')));
export const TasksViewPage = Loadable(lazy(() => import('../pages/dashboard/TasksViewPage')));
export const ReviewedTasks = Loadable(lazy(() => import('../pages/dashboard/ReviewedClaims')));
export const AnalystClaims = Loadable(lazy(() => import('../pages/dashboard/AnalystClaims')));
// export const TaskAccountPage = Loadable(lazy(() => import('../pages/dashboard/TaskAccountPage')));
export const TaskCreatePage = Loadable(lazy(() => import('../pages/dashboard/TaskCreatePage')));
export const TaskCreateNewPage = Loadable(lazy(() => import('../pages/dashboard/TaskCreateNewPage')));

// export const UserEditPage = Loadable(lazy(() => import('../pages/dashboard/UserEditPage')));
export const TaskDetailsPage = Loadable(lazy(() => import('../pages/dashboard/TaskDetailsPage')));


export const GPSPage = Loadable(lazy(() => import('../pages/dashboard/GPSPage')));

// TEST RENDER PAGE BY ROLE
export const PermissionDeniedPage = Loadable(
  lazy(() => import('../pages/dashboard/PermissionDeniedPage'))
);

// BLANK PAGE
export const BlankPage = Loadable(lazy(() => import('../pages/dashboard/BlankPage')));

// MAIN
export const Page500 = Loadable(lazy(() => import('../pages/Page500')));
export const Page403 = Loadable(lazy(() => import('../pages/Page403')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const HomePage = Loadable(lazy(() => import('../pages/HomePage')));
export const MaintenancePage = Loadable(lazy(() => import('../pages/MaintenancePage')));
export const OrgSelectPage = Loadable(lazy(() => import('../pages/OrgSelectPage')));
export const PrivacyPolicy = Loadable(lazy(() => import('../pages/PrivacyPolicy')));

// REPORTS
// ----------------------------------------------------------------------
export const AnimalsINvolvedMap = Loadable(lazy(() => import('../pages/dashboard/AnimalReportPage')));
